<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="justify-center">CATÁLOGO DE PÁGINAS</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <p>
                                    <router-link
                                        exact
                                        style="text-decoration: none"
                                        :to="{ name: 'inicioPanel' }"
                                    >
                                        Inicio
                                    </router-link>
                                    /
                                    <router-link
                                        exact
                                        style="text-decoration: none"
                                        :to="{
                                            name: 'pageDataCatalogPanel.index',
                                        }"
                                    >
                                        Catálogo de Páginas
                                    </router-link>
                                </p>
                            </v-col>

                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>

                            <!-- Filtros y botón crear -->
                            <v-col cols="12">
                                <v-row>
                                    <v-col xl="3" lg="3" md="3" sm="12" cols="12">
                                        <v-text-field
                                            @keyup.enter="
                                                page = 1;
                                                listarRegistros();
                                            "
                                            v-model="search"
                                            dense
                                            label="Buscar"
                                            outlined
                                            append-icon="mdi-magnify"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col xl="3" lg="3" md="3" sm="12" cols="12">
                                        <v-select
                                            @change="
                                                page = 1;
                                                listarRegistros();
                                            "
                                            v-model="pageSize"
                                            dense
                                            item-text="texto"
                                            item-value="valor"
                                            :items="arrCantidadRegistros"
                                            label="Registros"
                                            outlined
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        xl="6"
                                        lg="6"
                                        md="6"
                                        sm="12"
                                        cols="12"
                                        class="text-right"
                                    >
                                        <v-btn
                                            :to="{
                                                name: 'pageDataCatalogPanel.create',
                                            }"
                                            color="primary"
                                            large
                                        >
                                            <v-icon left large>mdi-plus</v-icon>
                                            CREAR
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Tabla de registros -->
                            <v-col cols="12">
                                <v-data-table
                                    :headers="[
                                        {
                                            text: 'URL',
                                            value: 'url_path',
                                            align: 'center',
                                        },
                                        {
                                            text: 'Título',
                                            value: 'title',
                                            align: 'center',
                                        },
                                        {
                                            text: 'Estado',
                                            value: 'estado',
                                            align: 'center',
                                        },
                                        {
                                            text: 'Acciones',
                                            value: 'actions',
                                            align: 'center',
                                        },
                                    ]"
                                    :items="arrRegistrosTabla"
                                    :loading="loaderListado"
                                    class="elevation-1"
                                    hide-default-footer
                                >
                                    <template v-slot:item.estado="{ item }">
                                        <v-chip
                                            :color="item.estado ? 'success' : 'error'"
                                            dark
                                            small
                                        >
                                            {{ item.estado ? 'Habilitado' : 'Inhabilitado' }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    :to="{
                                                        name: 'pageDataCatalogPanel.edit',
                                                        params: { id: item.id },
                                                    }"
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon>mdi-pencil</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    @click="objModalEliminar = item"
                                                    icon
                                                    color="error"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>

                                        <v-tooltip bottom v-if="!item.estado">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    @click="objModalHabilitar = item"
                                                    icon
                                                    color="success"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon>mdi-check-circle</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Habilitar</span>
                                        </v-tooltip>

                                        <v-tooltip bottom v-if="item.estado">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    @click="objModalInhabilitar = item"
                                                    icon
                                                    color="warning"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon>mdi-close-circle</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Inhabilitar</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-col>

                            <!-- Paginación -->
                            <v-col cols="12" class="text-center">
                                <v-pagination
                                    v-model="page"
                                    :length="cantidadPaginas"
                                    :total-visible="7"
                                    @input="listarRegistros()"
                                    :disabled="loaderListado"
                                ></v-pagination>
                            </v-col>

                            <!-- Mensaje sin registros -->
                            <v-col cols="12" v-show="alertRegistroNoEcontrado">
                                <v-alert type="error" dense outlined class="text-center">
                                    NO HAY REGISTROS DISPONIBLES PARA MOSTRAR
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modales -->
        <modal-eliminar
            v-if="objModalEliminar"
            :registro="objModalEliminar"
            @cerrar="objModalEliminar = null"
            @eliminado="
                objModalEliminar = null;
                listarRegistros();
            "
        />

        <modal-habilitar
            v-if="objModalHabilitar"
            :registro="objModalHabilitar"
            @cerrar="objModalHabilitar = null"
            @habilitado="
                objModalHabilitar = null;
                listarRegistros();
            "
        />

        <modal-inhabilitar
            v-if="objModalInhabilitar"
            :registro="objModalInhabilitar"
            @cerrar="objModalInhabilitar = null"
            @inhabilitado="
                objModalInhabilitar = null;
                listarRegistros();
            "
        />
    </v-container>
</template>

<script>
    import modalEliminar from './Eliminar';
    import modalHabilitar from './Habilitar';
    import modalInhabilitar from './Inhabilitar';

    export default {
        components: {
            modalEliminar,
            modalHabilitar,
            modalInhabilitar,
        },

        data() {
            return {
                arrCantidadRegistros: [
                    { texto: 10, valor: 10 },
                    { texto: 30, valor: 30 },
                    { texto: 50, valor: 50 },
                    { texto: 100, valor: 100 },
                    { texto: 500, valor: 500 },
                ],
                loaderListado: false,
                alertRegistroNoEcontrado: false,
                pageSize: 10,
                arrRegistrosTabla: [],
                page: 1,
                cantidadPaginas: 1,
                search: '',
                objModalEliminar: null,
                objModalHabilitar: null,
                objModalInhabilitar: null,
            };
        },

        mounted() {
            this.listarRegistros();
        },

        methods: {
            listarRegistros() {
                this.arrRegistrosTabla = [];
                this.loaderListado = true;
                this.alertRegistroNoEcontrado = false;

                this.axios({
                    method: 'GET',
                    url: 'api/panel/page-data-catalog',
                    params: {
                        pageSize: this.pageSize,
                        page: this.page,
                        search: this.search,
                    },
                })
                    .then((response) => {
                        const { data } = response;
                        this.arrRegistrosTabla = data.data;
                        this.cantidadPaginas = data.last_page;
                        this.alertRegistroNoEcontrado = this.arrRegistrosTabla.length === 0;
                    })
                    .catch(() => {
                        this.alertRegistroNoEcontrado = true;
                    })
                    .finally(() => {
                        this.loaderListado = false;
                    });
            },
        },
    };
</script>
